import React from 'react';
import Communication from '../UI/Communication';

const CommunicationsTab = ({ applicationId }) => {
  return (
    <Communication 
      entityId={applicationId} 
      entityType="job-application"
      showAddButton={true}
      showEditButtons={true}
    />
  );
};

export default CommunicationsTab;
